import lazyLoading from "./lazyLoading";

export default {
  name: "pages",
  meta: {
    icon: "fa-file-text",
    expanded: false,
    label: "Pages"
  },

  children: [
    {
      name: "admission-highschool",
      path: "/admin/pages/admission/highschool",
      meta: {
        title: "Procédure",
        label: "Procédure Supérieur"
      },
      component: lazyLoading("pages/admissionHighschoolProcess")
    },
    {
      name: "admission-school",
      path: "/admin/pages/admission/school",
      meta: {
        title: "Procédure",
        label: "Procédure Secondaire"
      },
      component: lazyLoading("pages/admissionSchoolProcess")
    },
    {
      name: "admission-eschool",
      path: "/admin/pages/admission/eschool",
      meta: {
        title: "Procédure",
        label: "Procédure E-learning"
      },
      component: lazyLoading("pages/admissionEschoolProcess")
    },
    {
      name: "contract-highschool",
      path: "/admin/pages/contract/highschool",
      meta: {
        title: "Contrat de scolarité",
        label: "Contrat Supérieur"
      },
      component: lazyLoading("pages/ContractHighschool")
    },
    {
      name: "contract-boardingschool",
      path: "/admin/pages/contract/boardingschool",
      meta: {
        title: "Contrat de scolarité",
        label: "Contrat Secondaire"
      },
      component: lazyLoading("pages/ContractBoardingschool")
    },

    {
      name: "contract-suisse",
      path: "/admin/pages/contract/suisse",
      meta: {
        title: "Contrat de scolarité",
        label: "Contrat Suisse"
        //isAdminStaff: true,
      },
      component: lazyLoading("pages/ContractSuisse")
    },
    {
      name: "contract-eschool",
      path: "/admin/pages/contract/eschool",
      meta: {
        title: "Contrat de formation",
        label: "Contrat E-learning"
      },
      component: lazyLoading("pages/ContractEschool")
    },
    {
      name: "cgv-school",
      path: "/admin/pages/cgv/school",
      meta: {
        title: "Conditions générales de vente",
        label: "CGV Secondaire"
      },
      component: lazyLoading("pages/CgvBoardingschool")
    },
    {
      name: "cgv-highschool",
      path: "/admin/pages/cgv/highschool",
      meta: {
        title: "Conditions générales de vente",
        label: "CGV Supérieur"
      },
      component: lazyLoading("pages/CgvHighschool")
    },
    {
      name: "cgv-eschool",
      path: "/admin/pages/cgv/eschool",
      meta: {
        title: "Conditions générales de vente",
        label: "CGV E-Learning"
      },
      component: lazyLoading("pages/CgvEschool")
    },
  ]
};
